import React, { useEffect } from "react";
import EventPlan from "../components/Event/EventPlan";
import Venue from "../components/Event/Venue";
import { Banner } from "../components/common/Banner";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { Loader } from "../components/common/Loader";
import { getEventData } from "../features/Event";


const Event: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { plan_event, meeting_venue, eventLoader, status } = useAppSelector(state => state.event);

    const { menu } = useAppSelector(state => state.menuAccess);
    const { meeting_events_sections } = menu?.meeting_events || {};
    useEffect(() => {
        dispatch(getEventData());
    }, [status, dispatch]);

    if (eventLoader) {
        return <Loader />;
    }
    return (
        <>

            <Banner banner_title={banner_title} />
            {
                meeting_events_sections && meeting_events_sections?.event_plan &&

                <EventPlan plan_event={plan_event} />
            }
            {
                meeting_events_sections && meeting_events_sections?.venue &&

                <Venue meeting_venue={meeting_venue} />
            }
        </>
    )
}
export default Event;